import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const ModalBody = styled("div")(() => ({
  margin: "12px 0",
  width: "100%",
}));

export const useStyles = makeStyles(() => ({
  saveButton: {
    backgroundColor: colors.success500,
    color: colors.white,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
    padding: "10px 20px",
  },
  cancelButton: {
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",

    "&:hover": {
      color: colors.gray600,
    },
  },
  modal: {
    maxWidth: "442px",
    width: "100%",
  },
}));
